module.exports = __webpack_public_path__ + "img/expect.1f60cea3.png";